export enum Text {
    DELIVERY_TEXT = "Filenames must only contain letters, numbers, dashes and underscores.",
    TOOLTIP_TITLE = `The following characters are considered invalid: (#, %, +, &, {, }, \\, <, >, *, ?, /, $, !, ", ', : , \`, ~, ; , (, ), [, ], @, ^, |, =, space)`,
}

export enum ErrorMessages {
    STITCH_ASSET_NAME = "Please enter a stitch asset name.",
    SOURCES_NOT_STITCHED = "Please add all sources to the siitching.",
    NO_SOURCE = "No source added.",
    SOURCE_NOT_MAPPED = "Source not mapped to delivery.",
    DELIVERY_NOT_MAPPED = "One or more deliveries do not have source(s) added to them.",
    WECO_ERROR = "You already have an eCO file type process added for the job",
}

export enum Info {
    KDM_DATES_WARNING = "The KDM Start/End window has been copied from a previous request. Please review the dates/times below before submitting.",
    DKDM_DATES_WARNING = "The DKDM Start/End window has been copied from a previous request. Please review the dates/times below before submitting.",
    PREMIERE_DATE_WARNING = "The Estimated Premiere Date has been copied from a previous request. Please review the date entered below before submitting.",
    FILENAME_WARNING = "Requested file names include special characters. Please validate file names are accurate before continuing.",
    IMPORT_WARNING="One or more required field has not been populated in the Excel template. Please edit the spreadsheet to include this additional Source information and reupload."
}

const popUpMessage = {
    'blu-ray': 'Blu-ray deliveries. Please select Manual from the delivery dropdown.',
    DCP: 'DCP deliveries. Please select either Drive or Aspera Faspex from the delivery dropdown.',
    other: 'Other deliveries. Please select Manual from the delivery dropdown.',
    multiple: 'Blu-ray and Other deliveries. Please select Manual from the delivery dropdown.'
}

export enum Morph {
    MORPH = "MORPh",
    FOUNDRY = "Foundry",
    WARNER_BROS_DISCOVERY = "Warner Bros. Discovery, Inc"
}

export const getAllowedMethod = (eventFlag) => {
    const { selected, key } = eventFlag;
    return `${selected} is not an available option for ${popUpMessage[key]}`
}

export const getPageTitle = (pageTitle = null,foundry = null) => {
    return `${pageTitle} : ${foundry}`
}

export enum TableClassname {
    DELIVERY_TABLE = "delivery-table"
}